import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Subscription, tap } from 'rxjs';

import { Account } from '@shared/account/models';
import { AuthRestaurantService } from '@tablesready/frontend-store';
import { PlanRestrictionsAlertService, PricePlansRestrictionsService } from '../../../services';
import { PlansAlertData } from '../../../models';

@Component({
  selector: 'tablesready-integrations',
  templateUrl: './integrations.component.html',
})
export class IntegrationsComponent implements OnInit, OnDestroy {
  account: Account | null = null;
  isLocationOnBusinessPlan = true;
  plansAlertData: PlansAlertData;

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly router: Router,
    private readonly authRestaurantService: AuthRestaurantService,
    private readonly pricePlansRestrictionsService: PricePlansRestrictionsService,
    private readonly planRestrictionsAlertService: PlanRestrictionsAlertService,
  ) {
  }

  ngOnInit(): void {
    const initialSubscription = this.authRestaurantService.selectWithAccount()
      .pipe(
        tap(user => {
          const { account, location } = user;
          this.account = account;
          this.isLocationOnBusinessPlan = this.pricePlansRestrictionsService.availableForBusinessPlan(account.subscriptionType, location.recurly);
          this.plansAlertData = this.planRestrictionsAlertService
            .getAlertData(
              account.subscriptionType,
              account.recurly,
              location.recurly,
            );
        }),
      )
      .subscribe();

    this.subscriptions.add(initialSubscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
